import React from 'react';
/**
 * Stats Component - to illustrate the possible functions
 * Could be used for nav buttons or overview
 */
 const Stats = ({
    currentStep,
    firstStep,
    goToStep,
    lastStep,
    nextStep,
    previousStep,
    totalSteps,
    step,
    isActive,
    type, 
    disabled
}) => (
    <React.Fragment>

        {isActive ? ( step < totalSteps ?
            (
                (step === 0) ? <React.Fragment><button className='btn btn-primary btn-lg' disabled={disabled} onClick={nextStep} style={{'paddingTop':'12px','paddingBottom':'12px'}} >Get Started</button> </React.Fragment>:
                (type === 'continue') ?
                <button className='btn btn-primary float-right' style={{'marginRight':'-11px'}} type="submit">Continue</button> :''
            )
            :
            (type === 'continue') ?
            <button className='btn btn-primary float-right' style={{'marginRight':'-11px'}} type="submit">Continue</button>:''
        ):<button className='btn btn-primary float-right' style={{'marginRight':'-1px'}} onClick={e => {e.preventDefault(); goToStep(step)}} type="button">Edit</button>
        }
        {/* { step > 1 &&
            <button className='btn btn-primary float-left' type="button" onClick={previousStep}>Go Back</button>
        } */}
        {/* <hr /> */}
        {/* <div style={{ fontSize: '21px', fontWeight: '200' }}>
            {currentStep == 1 ? '':
            <div>
                <div>Current Step: {currentStep-1}</div>
                <div>Total Steps: {totalSteps-1}</div>
            </div>
            }
            <button className='btn btn-block btn-default' onClick={() => goToStep(2)}>First Step</button>
            <button className='btn btn-block btn-default' onClick={lastStep}>Last Step</button>
            <button className='btn btn-block btn-default' onClick={() => goToStep(3)}>Go to Step 2</button>
        </div> */}
    </React.Fragment>
);
export default Stats;